import type { UseQueryOptions } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import { coverageService } from '../services/coverage.service';

import type { CoverageViewModel } from '../types/CoverageViewModel';
import type { ApiResponse, ErrorResponse } from '../services/api.types';
import type { CoverageTimelineViewModel } from '../types/CoverageTimelineViewModel';

export const useCoverageTimelineById = (
  comboId: number,
  coverageId: number,
  options?: UseQueryOptions<ApiResponse<CoverageTimelineViewModel>, ErrorResponse>
) =>
  useQuery<ApiResponse<CoverageTimelineViewModel>, ErrorResponse>({
    queryKey: ['coverageTimelineData', comboId, coverageId],
    queryFn: () => coverageService.getCoverageTimelineById(comboId, coverageId),
    enabled: !!comboId && !!coverageId,
    ...options,
  });

export const useCoverageById = (
  comboId: number,
  coverageId: number,
  options?: UseQueryOptions<ApiResponse<CoverageViewModel>, ErrorResponse>
) =>
  useQuery<ApiResponse<CoverageViewModel>, ErrorResponse>({
    queryKey: ['coverage', comboId, coverageId],
    queryFn: () => coverageService.getCoverageById(comboId, coverageId),
    enabled: !!comboId && !!coverageId,
    ...options,
  });
